<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  @if (!title) {
    <div i18n="@@changeImage">Change Image</div>
  }
  @if (title) {
    <div i18n="@@addNewImage">Add New Image</div>
  }
  <mat-icon (click)="closeDialog()" class="cursor" i18n-label="@@closeDialogIcon" aria-label="Close">close</mat-icon>
</div>

<div class="col-md-12 med-dialog-container pt-0">
  <mat-dialog-content class="mat-typography">
    <input data-testid="img_file" #selectFileInput accept="image/*" type="file" (change)="fileChangeEvent($event)" />
    <div class="profile-image-container">
      @if (!existingImage && !cropperReady && !title) {
        <img class="avatar-image" src="/assets/images/avatar.png" alt="@@profileImageAlt">
      }
      @if (!existingImage && !cropperReady && title) {
        <img class="placeholder" src="{{utils.isDarkMode() ? '../../../assets/images/products-dark.png' : '../../../assets/images/products-light.png'}}" alt="@@profileImageAlt">
      }
      @if (existingImage && !cropperReady) {
        <img class="avatar-image" [src]="existingImage" alt="@@profileImageAlt">
      }
      <image-cropper
        #imageCropper
        [imageBase64]="imageBase64"
        [imageChangedEvent]="imageChangedEvent"
        [maintainAspectRatio]="!resizeImage || aspectRatio"
        [resizeToWidth]="resizeImage ? 'auto' : 150"
        [aspectRatio]="1 / 1"
        [roundCropper]="false"
        (imageCropped)="imageCropped($event)"
        (imageLoaded)="imageLoaded()"
        (loadImageFailed)="imageLoadFailed()"
        style="max-height: 60vh"
        [style.display]="cropperReady ? null : 'none'"
      ></image-cropper>
    </div>

    <mat-dialog-actions>
      <div>
        @if (!existingImage) {
          <button i18n="@@add" data-testid="add_image_button" mat-stroked-button color="primary" (click)="uploadNewPhoto()">Add</button>
        }
        @if (existingImage) {
          <button i18n="@@browse" data-testid="browse_image_button" mat-stroked-button color="primary" (click)="uploadNewPhoto()">Browse</button>
        }
        <button i18n="@@save" data-testid="save_profile_image_button" mat-raised-button class="" (click)="savePhotoChanges()" color="primary">Save</button>
      </div>
    </mat-dialog-actions>
  </mat-dialog-content>
</div>
